import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'prodgenerator';

const prodgeneratorService = {
  getOrders: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orders`,
      data,
    });
  },

  getOrderRows: async (sources, signal) => {
    const rows = [];
    for (let index = 0; index < sources.length; index += 100) {
      const result = await request({
        method: Methods.POST, resource: `${baseURL}/orderRows`,
        data: { sources: sources.slice(index, index + 100) }, signal,
      });
      rows.push(...result.rows);
    }
    return rows;
  },

  getsourcelistByItemCode: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/sourcelistByItemCode`,
      data,
    });
  },

  createProduction: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/createProduction`,
      data,
    });
  },

  enqueueGroups: (submissionId, productions) => request({
    method: Methods.POST, resource: `${baseURL}/groups`, data: { submissionId, productions },
  }),

  getGroupRows: async (signal, payloadCache = new Map()) => {
    const readPages = async (resource) => {
      const rows = [];
      let page = 0;
      let rowCount;
      do {
        const result = await request({
          method: Methods.GET, resource: `${baseURL}/${resource}`, params: { page, pageSize: 100 }, signal,
        });
        rows.push(...result.rows);
        rowCount = result.rowCount;
        page += 1;
      } while (page * 100 < rowCount);
      return rows;
    };
    const groups = await readPages('groups');
    if (groups.some((group) => !payloadCache.has(group.id))) {
      const details = await readPages('groupRows');
      details.forEach((group) => payloadCache.set(group.id, group.payload));
    }
    const activeIds = new Set(groups.map((group) => group.id));
    for (const id of payloadCache.keys()) if (!activeIds.has(id)) payloadCache.delete(id);
    return groups.filter((group) => payloadCache.has(group.id)).map((group) => ({ ...group, payload: payloadCache.get(group.id) }));
  },

  retryGroup: (id) => request({ method: Methods.POST, resource: `${baseURL}/groups/${id}/retry` }),

  getAllSourceDataByItemCodes: (itemCodes) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/allSourceDataByItemCodes`,
      data: { itemCodes },
    });
  },

  updateOrderLine: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default prodgeneratorService;
